import React from 'react';

import { useAuth } from '~/auth/use-auth';
import { m } from '~/paraglide/messages.js';

export const ChatInitial = React.memo(() => {
  const { user } = useAuth();

  return (
    <div className="flex flex-col items-center justify-center flex-grow px-2 md:px-0">
      <div className="w-full max-w-3xl flex flex-col items-center space-y-6">
        <div className="text-center space-y-2 p-4">
          <h1 className="text-4xl font-semibold">
            {m['chat.welcome']({
              name: user?.profile.first_name || '',
            })}
          </h1>
          <p className="text-2xl font-semibold">
            {m['chat.welcome_subtitle']?.() ||
              "It's a pleasure to have you here"}
          </p>
        </div>
      </div>
    </div>
  );
});
